import { WarningIcon } from '~components/icons/WarningIcon';
import { useLabel } from '~hooks/useLabels';

export function LoadingError() {
  const label = useLabel('labelMediaLibraryLoadingError');
  return (
    <div className="ml--error-loading flex bg-white rounded-md p-4 items-center jusitfy-center">
      <WarningIcon className="text-red w-6 h-6 mr-2" />
      <div className="font-sans text-sm text-black">{label}</div>
    </div>
  );
}
